var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isBannedBrowser
    ? _c("div", { staticClass: "text-center p-4" }, [
        _vm._v("Browser not supported"),
      ])
    : _c(
        "div",
        { attrs: { id: "app" } },
        [
          _c("TopNav"),
          _vm._v(" "),
          _vm.loaded
            ? _c("router-view", { key: "1" })
            : _c("div", { key: "2", staticClass: "text-center my-6" }, [
                _c(
                  "div",
                  { staticClass: "spinner-border", attrs: { role: "status" } },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                ),
              ]),
          _vm._v(" "),
          _c("Review"),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }